import * as React from 'react'
import { ContextMenu as ContextMenuPrimitive } from 'radix-ui'

import { cn } from '@shared/ui/lib/utils'

const ContextMenu = ContextMenuPrimitive.Root
const ContextMenuTrigger = ContextMenuPrimitive.Trigger
const ContextMenuPortal = ContextMenuPrimitive.Portal

const ContextMenuContent = React.forwardRef<
  React.ComponentRef<typeof ContextMenuPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof ContextMenuPrimitive.Content>
>(function ContextMenuContent({ className, ...props }, ref) {
  return (
    <ContextMenuPortal>
      <ContextMenuPrimitive.Content
        className={cn(
          'z-50 min-w-48 overflow-hidden rounded-md border border-[var(--lms-color-border-strong)] bg-[var(--lms-color-surface-card)] p-1 text-[var(--lms-color-ink-strong)] shadow-lg outline-none',
          className,
        )}
        data-slot="context-menu-content"
        ref={ref}
        {...props}
      />
    </ContextMenuPortal>
  )
})

const ContextMenuItem = React.forwardRef<
  React.ComponentRef<typeof ContextMenuPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof ContextMenuPrimitive.Item>
>(function ContextMenuItem({ className, ...props }, ref) {
  return (
    <ContextMenuPrimitive.Item
      className={cn(
        'relative flex min-h-10 cursor-default select-none items-center gap-2 rounded-sm px-2.5 py-2 text-sm font-semibold outline-none transition-colors focus:bg-[var(--lms-color-surface-warm)] focus:text-[var(--lms-color-ink-strong)] data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        className,
      )}
      data-slot="context-menu-item"
      ref={ref}
      {...props}
    />
  )
})

const ContextMenuSeparator = React.forwardRef<
  React.ComponentRef<typeof ContextMenuPrimitive.Separator>,
  React.ComponentPropsWithoutRef<typeof ContextMenuPrimitive.Separator>
>(function ContextMenuSeparator({ className, ...props }, ref) {
  return (
    <ContextMenuPrimitive.Separator
      className={cn('my-1 h-px bg-[var(--lms-color-border-subtle)]', className)}
      data-slot="context-menu-separator"
      ref={ref}
      {...props}
    />
  )
})

export {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuPortal,
  ContextMenuSeparator,
  ContextMenuTrigger,
}
